import { render } from "./ResourceCollection.vue?vue&type=template&id=d8338ee4"
import script from "./ResourceCollection.vue?vue&type=script&lang=js"
export * from "./ResourceCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__